@import 'styles/variables';

.wrapper {
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  transform: translate(-50%, -16px);
  z-index: 4;
}

:export {
  rightRailWidth: $right-rail-selector-width;
}
